// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageStatic_root__37LKM","unsupportedOverlay":"MessageStatic_unsupportedOverlay__2z6HM"};